import { getLogs } from "@/services/logs";
import { State } from "@/utils/interfaces";

export const SET_LOGS = "setLogs";

export default {
  namespaced: true,
  state: {
    logs: []
  },
  getters: {
    logs: ({ logs }: State): any => logs,
  },
  mutations: {
    [SET_LOGS](state: State, payload: any): void {
      state.logs = payload;
    },
  },
  actions: {
    setLogs: ({ commit }: any, logs: any): void => {
      commit(SET_LOGS, logs);
    },
    async fetchLogs({ dispatch }: any, payload: any): Promise<any> {
      const logs: any = await getLogs(payload);
      dispatch("setLogs", logs.data);
      return logs.data;
    },
  },
}
